import React from 'react';
import { AICharacter } from '../../services/aiCharacterService';
import './AICharacterCard.css';

interface AICharacterCardProps {
  character: AICharacter;
  onClick: () => void;
  onDelete: () => void;
}

const AICharacterCard: React.FC<AICharacterCardProps> = ({ character, onClick, onDelete }) => {
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div className="ai-character-card" onClick={onClick}>
      <div className="ai-character-card-header">
        <h3 className="ai-character-card-name">{character.name}</h3>
        <button 
          className="ai-character-card-delete-btn"
          onClick={handleDeleteClick}
          title="Delete character"
        >
          ×
        </button>
      </div>
      <div className="ai-character-card-body">
        <div className="ai-character-card-info">
          <span className="ai-character-card-provider">{character.model_provider}</span>
          <span className="ai-character-card-model">/{character.model_name}</span>
        </div>
        {character.persona_info && typeof character.persona_info === 'object' && character.persona_info.description && (
          <p className="ai-character-card-description">
            {typeof character.persona_info.description === 'string' 
              ? character.persona_info.description.substring(0, 100) + (character.persona_info.description.length > 100 ? '...' : '')
              : JSON.stringify(character.persona_info).substring(0, 100) + '...'}
          </p>
        )}
        <div className="ai-character-card-status">
          <span className={`ai-character-card-status-badge ${character.is_active ? 'active' : 'inactive'}`}>
            {character.is_active ? 'Active' : 'Inactive'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AICharacterCard;

